/**
 * Created by Jan Bradac on 21.8.2016.
 */

(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
     Lfl.Modals;

    (function (Modals, $, undefined) {
        if(Lfl.Files.isLoadedAlready(Lfl.Modals, 'BootstrapMultipleModalsFixer')) {
            return;
        }

        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         * Allows multiple Bootstrap modals to be opened at the same time.
         *
         * Based on:
         * http://stackoverflow.com/a/24914782/5500468
         * With addition from http://stackoverflow.com/a/33983908/5500468
         *
         * @memberOf Lfl.Modals
         */
        Lfl.Modals.BootstrapMultipleModalsFixer;

        (function (BootstrapMultipleModalsFixer, $, undefined) {
            /*
            |===========================================================================================================
            | Object definition
            |===========================================================================================================
            */

            /*
            |-----------------------------------------------------------------------------------------------------------
            | Public methods
            |-----------------------------------------------------------------------------------------------------------
            */

            /**
             * Runs the fix.
             * @memberOf Lfl.Modals.BootstrapMultipleModalsFixer
             */

            BootstrapMultipleModalsFixer.applyFix = function () {
                $(document).on('show.bs.modal', '.modal', function () {
                    var zIndex = 1040 + (10 * $('.modal:visible').length);
                    var $this = $(this);
                    $this.css('z-index', zIndex);
                    setTimeout(function() {
                        $($this.find('.modal-backdrop')[0]).not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
                        // Additional fix to actually make the stack correct.
                        $($this.find('.modal-dialog')[0]).not('.modal-stack').css('z-index', zIndex).addClass('modal-stack');
                    }, 0);
                });

                $(document).on('hidden.bs.modal', '.modal', function () {
                    $('.modal:visible').length && $(document.body).addClass('modal-open');
                });
            };


            /*
            |-----------------------------------------------------------------------------------------------------------
            | Private methods
            |-----------------------------------------------------------------------------------------------------------
            */
        }(Modals.BootstrapMultipleModalsFixer = Modals.BootstrapMultipleModalsFixer || {}, jQuery));
    }(Lfl.Modals = Lfl.Modals || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
